import React, { useContext, useState, } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';
import FetchApi from '../api/getAxios';
import { useParams } from 'react-router-dom';

export const ReportContext = React.createContext();


export const ReportProvider = ({ children }) => {

    const [isFetching, setIsFetching] = useState(false);
    const [businessOverview, setBusinessOverview] = useState(null);
    const [businessTopSell, setBusinessTopSell] = useState([]);
    const [businessBestSell, setBusinessBestSell] = useState([]);
    const [businessChart, setBusinessChart] = useState([]);

    const [storeOverview, setStoreOverview] = useState(null);
    const [storeTopSell, setStoreTopSell] = useState([]);
    const [storeBestSell, setStoreBestSell] = useState([]);
    const [storeChart, setStoreChart] = useState([]);

    const { btoken, stoken } = useUserContext();

    // Get Business Overview
    const getBusinessOverview = async ({ month, year }) => {
        setIsFetching(true);
        const data = { btoken, stoken, month, year };
        FetchApi.post(`/reports/overview.business`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setBusinessOverview([]);
                    } else {
                        setIsFetching(false);
                        setBusinessOverview(res.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Get Business Best Selling
    const getBusinessBestSell = async ({ month, year }) => {
        setIsFetching(true);
        const data = { btoken, stoken, month, year };
        FetchApi.post(`/reports/bestSelling.business`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setBusinessBestSell([]);
                    } else {
                        setIsFetching(false);
                        setBusinessBestSell(res.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Get Business Top Selling
    const getBusinessTopSell = async ({ month, year }) => {
        setIsFetching(true);
        const data = { btoken, stoken, month, year };
        FetchApi.post(`/reports/topSell.business`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setBusinessTopSell([]);
                    } else {
                        setIsFetching(false);
                        setBusinessTopSell(res.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Get Business Chart
    const getBusinessChart = async ({ year }) => {
        setIsFetching(true);
        const data = { btoken, stoken, year };
        FetchApi.post(`/reports/chart.business`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setBusinessChart([]);
                    } else {
                        setIsFetching(false);
                        setBusinessChart(res.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Filter with month and year for Busniess
    const handleBusinessFilter = ({ month = '', year = '' }) => {

        getBusinessOverview({ month, year });
        getBusinessTopSell({ month, year });
        getBusinessBestSell({ month, year });
        getBusinessChart({ year });


    };


    // Get Store Overview
    const getStoreOverview = async ({ storeToken, month, year }) => {
        setIsFetching(true);
        const data = { btoken, stoken: storeToken, month, year };
        FetchApi.post(`/reports/overview.store`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setStoreOverview([]);
                    } else {
                        setIsFetching(false);
                        setStoreOverview(res?.data?.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Get Store Best Selling
    const getStoreBestSell = async ({ storeToken, month, year }) => {
        setIsFetching(true);
        const data = { btoken, stoken: storeToken, month, year };
        FetchApi.post(`/reports/bestSelling.store`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setStoreBestSell([]);
                    } else {
                        setIsFetching(false);
                        setStoreBestSell(res.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Get Store Top Selling
    const getStoreTopSell = async ({ storeToken, month, year }) => {
        setIsFetching(true);
        const data = { btoken, stoken: storeToken, month, year };
        FetchApi.post(`/reports/topSell.store`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setStoreTopSell([]);
                    } else {
                        setIsFetching(false);
                        setStoreTopSell(res.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Get Store Chart
    const getStoreChart = async ({ storeToken, year }) => {
        setIsFetching(true);
        const data = { btoken, stoken: storeToken, year };
        FetchApi.post(`/reports/chart.store`, data)
            .then((res) => {
                if (res.success === false) { setIsFetching(false); } else {
                    if (res.data === false) {
                        setIsFetching(false);
                        setStoreChart([]);
                    } else {
                        setIsFetching(false);
                        setStoreChart(res.data);
                    }
                }
            })
            .catch(() => { setIsFetching(false); });
    };

    // Filter with month and year for Busniess
    const handleStoreFilter = ({ storeToken = '', month = '', year = '' }) => {

        getStoreOverview({ storeToken, month, year });
        getStoreTopSell({ storeToken, month, year });
        getStoreBestSell({ storeToken, month, year });
        getStoreChart({ storeToken, year });


    };




    return (
        <ReportContext.Provider value={{

            handleBusinessFilter,
            getBusinessBestSell, getBusinessTopSell, getBusinessOverview, getBusinessChart,
            businessBestSell, businessTopSell, businessOverview, businessChart,

            handleStoreFilter,
            getStoreBestSell, getStoreTopSell, getStoreOverview, getStoreChart,
            storeBestSell, storeTopSell, storeOverview, storeChart,

            isFetching,

        }}>
            {children}
        </ReportContext.Provider>
    );
};

// make sure use
export const useReportContext = () => {
    return useContext(ReportContext);
};
